import services from '../services'
import * as types from './mutation-types'

export const getAll = ({ commit }, params) => (
  services.list(params).then(res => {
    commit(types.SET_ROOMS, res.data)
  })
)

export const getListRooms = async ({ commit }, params) => (
  services.list(params).then(res => {
    return res.data
  })
)

export const getRoom = async ({ commit }, id) => {
  await services.show(id).then(res => {
    commit(types.SET_ROOM, res.data.data)
  })
}

export const save = async ({ commit }, obj) => {
  await services.saveRoom(obj).then(res => {
    commit(types.SET_ROOM, res.data.data)
    return res
  })
}

export const changeStatus = async ({ commit }, obj) => {
  await services.changeStatus(obj).then(res => {
    return res
  })
}

export const deleteRoom = async ({ commit }, id) => {
  await services.delRoom(id).then(res => {
    return res
  })
}
